module.exports = __webpack_public_path__ + "static/media/vegitables_20.695387c7.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_20.csv
// module id = 603
// module chunks = 0